import { useServer } from "@shared/hooks/useServer/useServer";

import { checkIsEmerson } from "./checkIsEmerson";

/**
 * Used to verify if the current app is Emerson or Fullscript.
 * @see `app/javascript/shared/hooks/useCheckIsEmerson/checkIsEmerson.ts` for non-hook usage.
 *
 * @returns true if running in Emerson, false if on Fullscript.
 */
const useCheckIsEmerson = () => {
  const { origin, url } = useServer();

  return checkIsEmerson({ origin, pathname: url });
};

export { useCheckIsEmerson };
